import React from 'react';
import styled from 'styled-components';

const InfoTitleText = styled.span`
  color: var(--luft-primary);
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 10px;
  font-family: "Work Sans";
`;

const InfoTitle = ({ children, ...props }) => (
  <InfoTitleText {...props}>{children}</InfoTitleText>
);

export default InfoTitle;
